import React from "react";
import { Link } from "react-router-dom";

// Style \\
import "../../assets/styles/cards/doctorsCard.scss";

// Images \\
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

// Images \\
import doctors_avatar from "../../assets/images/doctorsAvatar.svg";

const DoctorsCard = () => {
  return (
    <div className="card_box">
      <div className="card">
        <div className="card_item">
          <div className="card_items_img">
            <img src={doctors_avatar} alt="avatar" />
          </div>
          <div className="card_items_content">
            <p className="name">Doctor’s Name</p>
            <p className="field">Neurology</p>
          </div>
          <div className="card_items_social">
            <Link href="" target="_blank">
              <div className="anchor_box">
                <FaLinkedinIn className="social_icons" />
              </div>
            </Link>
            <Link href="" target="_blank">
              <div className="anchor_box">
                <FaFacebookF className="social_icons" />
              </div>
            </Link>
            <Link href="" target="_blank">
              <div className="anchor_box">
                <FaInstagram className="social_icons" />
              </div>
            </Link>
          </div>
        </div>
        <div className="card_items_link">
          <Link to={"/doctorsProfile"} className="view_profile">
            <div className="link_innerDiv">View Profile</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DoctorsCard;
